export { default } from './ProviderCTA';
